/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { LIMIT_USAGE } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const fetchLimitUsageUrl = `${getFullUrl('app-api')}/feature/store/v1/usage`;
export const fetchLimitUsage = () => {
  const earlyRequest = getEarlyRequesterResult(LIMIT_USAGE);
  const fetchLimitUsagePromise = () => http.get(fetchLimitUsageUrl);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => fetchLimitUsagePromise()) : null;
  return earlyRequestWithRetry || fetchLimitUsagePromise();
};